var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 72,
    viewBox: "0 0 68 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_959_1739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.44705 31.4072L9.97643 35.777C10.2019 35.7054 10.4332 35.6479 10.6684 35.6048L9.46129 32.1629C9.37245 31.9783 9.23455 31.8139 9.05851 31.6827C8.88247 31.5516 8.67313 31.4572 8.44705 31.4072Z",
    fill: "#00527C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2547 33.8644L12.9089 35.559C13.2272 35.6104 13.5392 35.6831 13.8414 35.7761L13.6667 35.3181C13.6636 35.3105 13.661 35.3034 13.6583 35.295C13.4512 34.6932 12.9469 34.1792 12.2547 33.8644Z",
    fill: "#00527C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.905 31.4072C58.6789 31.4573 58.4696 31.5516 58.2935 31.6828C58.1175 31.8139 57.9796 31.9784 57.8908 32.163L56.6837 35.6048C56.9189 35.6479 57.1502 35.7054 57.3758 35.777L58.905 31.4072Z",
    fill: "#00527C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6911 35.295C53.6885 35.3026 53.6858 35.3105 53.6827 35.3181L53.508 35.7761C53.8103 35.6831 54.1222 35.6104 54.4405 35.559L55.0947 33.8644C54.4025 34.1792 53.8982 34.6932 53.6911 35.295Z",
    fill: "#00527C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1424 51.8678L20.1764 55.7143L27.1656 51.2315C26.9964 50.7951 26.8946 50.3423 26.8626 49.8843L26.7582 48.3751C26.5449 47.1315 25.927 45.9612 24.9722 44.9926C24.0174 44.024 22.7628 43.2947 21.3459 42.8845L20.7457 42.7096C19.6618 42.3921 18.6768 41.8744 17.8638 41.1947L13.9467 37.9111C13.5014 37.5386 12.9312 37.2885 12.3121 37.1942C11.693 37.0999 11.0544 37.1659 10.4811 37.3833L13.0351 39.3384C14.1324 40.1788 15.1359 41.1013 16.0331 42.0944C16.1978 42.2768 16.2693 42.5066 16.2319 42.7331C16.1945 42.9597 16.0512 43.1645 15.8336 43.3026C15.616 43.4406 15.3419 43.5005 15.0716 43.4692C14.8013 43.4378 14.5569 43.3177 14.3922 43.1353C13.5708 42.226 12.6521 41.3814 11.6475 40.612L8.15428 37.9373C8.05163 37.8587 7.96903 37.7636 7.91147 37.6575C7.85391 37.5515 7.82259 37.4368 7.81938 37.3203C7.81618 37.2038 7.84116 37.088 7.89283 36.9798C7.94449 36.8717 8.02177 36.7734 8.11999 36.691C8.13371 36.6795 8.14811 36.6687 8.162 36.6575L8.02276 36.2805L5.79111 30.0264C5.66998 29.6849 5.4386 29.3781 5.12252 29.1399C4.80645 28.9017 4.41797 28.7413 4 28.6765L6.96404 42.0464C7.5968 43.5666 8.78608 44.8806 10.3623 45.8009L17.3072 49.811C18.1964 50.2641 18.8473 50.9832 19.1287 51.8229C19.1337 51.8377 19.1381 51.8528 19.1424 51.8678Z",
    fill: "url(#paint0_linear_959_1739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9147 63.6331L30.0215 57.6385V51.8894L18.9147 58.832V63.6331Z",
    fill: "url(#paint1_linear_959_1739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.321 57.6385L48.4278 63.6331V58.832L37.321 51.8894V57.6385Z",
    fill: "url(#paint2_linear_959_1739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5562 30.0257L59.3269 36.2727L59.1848 36.6576C59.1986 36.6689 59.2131 36.6795 59.2268 36.6911C59.325 36.7736 59.4023 36.8718 59.4539 36.98C59.5056 37.0881 59.5306 37.204 59.5274 37.3204C59.5242 37.4369 59.4929 37.5516 59.4353 37.6577C59.3777 37.7637 59.2951 37.8589 59.1925 37.9374L55.6993 40.612C54.6947 41.3814 53.7759 42.2261 52.9543 43.1355C52.8728 43.2258 52.7708 43.3018 52.6543 43.359C52.5377 43.4163 52.4088 43.4538 52.275 43.4693C52.1411 43.4848 52.0049 43.4781 51.8742 43.4495C51.7434 43.421 51.6207 43.3711 51.5129 43.3027C51.4052 43.2344 51.3145 43.1489 51.2462 43.0512C51.1779 42.9535 51.1332 42.8455 51.1146 42.7333C51.0961 42.6211 51.1041 42.507 51.1382 42.3974C51.1723 42.2878 51.2319 42.1849 51.3134 42.0946C52.2108 41.1012 53.2145 40.1785 54.312 39.338L56.8659 37.3832C56.2927 37.1658 55.654 37.0998 55.0349 37.194C54.4158 37.2883 53.8456 37.5383 53.4002 37.9108L49.4821 41.195C48.6691 41.8746 47.6841 42.3924 46.6001 42.7099L46.001 42.8845C44.584 43.2947 43.3293 44.024 42.3745 44.9926C41.4197 45.9612 40.8017 47.1315 40.5884 48.3751L40.4839 49.8843C40.452 50.3423 40.3501 50.7951 40.1809 51.2315L47.1703 55.7143L48.2044 51.8678C48.2087 51.8534 48.2131 51.8377 48.2181 51.8229C48.4996 50.9834 49.1506 50.2646 50.0396 49.8115L56.987 45.7996C58.562 44.8794 59.7503 43.5659 60.3824 42.0464L63.3465 28.6765C62.9288 28.7413 62.5405 28.9016 62.2246 29.1397C61.9087 29.3778 61.6774 29.6844 61.5562 30.0257Z",
    fill: "url(#paint3_linear_959_1739)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_959_1739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0364 33.3193C32.7418 33.3193 32.4593 33.4094 32.251 33.5697C32.0427 33.73 31.9257 33.9474 31.9257 34.1741V36.8343C31.9257 37.061 32.0427 37.2784 32.251 37.4387C32.4593 37.599 32.7418 37.6891 33.0364 37.6891C33.3309 37.6891 33.6134 37.599 33.8217 37.4387C34.03 37.2784 34.147 37.061 34.147 36.8343V34.1741C34.147 33.9474 34.03 33.73 33.8217 33.5697C33.6134 33.4094 33.3309 33.3193 33.0364 33.3193Z",
    fill: "url(#paint4_linear_959_1739)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_959_1739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0364 39.3268C32.7418 39.3268 32.4593 39.4157 32.251 39.574C32.0427 39.7324 31.9257 39.9471 31.9257 40.171V45.3103C31.9257 45.4212 31.9544 45.531 32.0102 45.6334C32.066 45.7358 32.1479 45.8289 32.251 45.9073C32.3541 45.9857 32.4766 46.0478 32.6113 46.0903C32.7461 46.1327 32.8905 46.1545 33.0364 46.1545C33.1822 46.1545 33.3266 46.1327 33.4614 46.0903C33.5961 46.0478 33.7186 45.9857 33.8217 45.9073C33.9249 45.8289 34.0067 45.7358 34.0625 45.6334C34.1183 45.531 34.147 45.4212 34.147 45.3103V40.171C34.147 39.9471 34.03 39.7324 33.8217 39.574C33.6134 39.4157 33.3309 39.3268 33.0364 39.3268Z",
    fill: "url(#paint5_linear_959_1739)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_959_1739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9094 42.8303V40.7403C38.9094 40.5104 38.8091 40.2899 38.6305 40.1274C38.452 39.9649 38.2098 39.8735 37.9574 39.8735C37.7049 39.8735 37.4627 39.9649 37.2842 40.1274C37.1056 40.2899 37.0053 40.5104 37.0053 40.7403V42.8303C37.0053 43.0602 37.1056 43.2807 37.2842 43.4432C37.4627 43.6057 37.7049 43.6971 37.9574 43.6971C38.2098 43.6971 38.452 43.6057 38.6305 43.4432C38.8091 43.2807 38.9094 43.0602 38.9094 42.8303Z",
    fill: "url(#paint6_linear_959_1739)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_959_1739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0053 31.7131V37.9293C37.0053 38.1552 37.1056 38.3719 37.2842 38.5317C37.4627 38.6915 37.7049 38.7812 37.9574 38.7812C38.2098 38.7812 38.452 38.6915 38.6305 38.5317C38.8091 38.3719 38.9094 38.1552 38.9094 37.9293V31.7131C38.9094 31.4871 38.8091 31.2704 38.6305 31.1106C38.452 30.9508 38.2098 30.8611 37.9574 30.8611C37.7049 30.8611 37.4627 30.9508 37.2842 31.1106C37.1056 31.2704 37.0053 31.4871 37.0053 31.7131Z",
    fill: "url(#paint7_linear_959_1739)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_959_1739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0737 31.7148C29.0737 31.4884 28.9734 31.2712 28.7949 31.1111C28.6164 30.951 28.3742 30.8611 28.1217 30.8611C27.8692 30.8611 27.6271 30.951 27.4485 31.1111C27.27 31.2712 27.1697 31.4884 27.1697 31.7148V34.3771C27.1697 34.6036 27.27 34.8207 27.4485 34.9808C27.6271 35.1409 27.8692 35.2308 28.1217 35.2308C28.3742 35.2308 28.6164 35.1409 28.7949 34.9808C28.9734 34.8207 29.0737 34.6036 29.0737 34.3771V31.7148Z",
    fill: "url(#paint8_linear_959_1739)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_959_1739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1217 37.9612C27.8692 37.9612 27.6271 38.051 27.4485 38.2109C27.27 38.3708 27.1697 38.5877 27.1697 38.8139V41.4782C27.1697 41.7044 27.27 41.9213 27.4485 42.0812C27.6271 42.2411 27.8692 42.3309 28.1217 42.3309C28.3742 42.3309 28.6164 42.2411 28.7949 42.0812C28.9734 41.9213 29.0737 41.7044 29.0737 41.4782V38.8139C29.0737 38.5877 28.9734 38.3708 28.7949 38.2109C28.6164 38.051 28.3742 37.9612 28.1217 37.9612Z",
    fill: "url(#paint9_linear_959_1739)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.6749 9.01257C33.5179 9.01254 33.3645 9.05256 33.2341 9.12757C33.1036 9.20257 33.0019 9.3092 32.9418 9.43396C32.8817 9.55871 32.866 9.696 32.8966 9.82846C32.9272 9.96091 33.0027 10.0826 33.1137 10.1781C33.2246 10.2736 33.366 10.3386 33.5199 10.365C33.6738 10.3913 33.8333 10.3778 33.9783 10.3262C34.1232 10.2745 34.2471 10.187 34.3343 10.0747C34.4215 9.9624 34.468 9.83039 34.468 9.69535C34.4678 9.51436 34.3841 9.34085 34.2354 9.21287C34.0867 9.08488 33.8852 9.01285 33.6749 9.01257Z",
    fill: "#289FD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6749 4.91565C33.5179 4.91562 33.3645 4.95566 33.234 5.0307C33.1035 5.10574 33.0018 5.2124 32.9417 5.33721C32.8817 5.46201 32.866 5.59933 32.8966 5.73181C32.9273 5.86428 33.0029 5.98595 33.114 6.08143C33.225 6.1769 33.3664 6.24188 33.5204 6.26816C33.6743 6.29443 33.8339 6.28081 33.9789 6.22902C34.1238 6.17724 34.2477 6.08961 34.3347 5.97722C34.4218 5.86484 34.4682 5.73276 34.468 5.59768C34.4676 5.41681 34.3838 5.24347 34.2352 5.11563C34.0865 4.9878 33.885 4.91589 33.6749 4.91565Z",
    fill: "#27AAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8416 15.0519V13.6461C46.8414 13.5329 46.7937 13.4233 46.7066 13.3359C46.6195 13.2484 46.4985 13.1884 46.3639 13.166L37.5568 11.7142C37.3205 11.6753 37.1079 11.5701 36.9552 11.4165C36.8024 11.2629 36.719 11.0704 36.719 10.8719V2.51092C36.719 1.84498 36.398 1.20632 35.8266 0.735431C35.2553 0.264542 34.4803 0 33.6723 0C32.8643 0 32.0893 0.264542 31.5179 0.735431C30.9466 1.20632 30.6256 1.84498 30.6256 2.51092V10.8716C30.6256 11.0702 30.5421 11.2626 30.3894 11.4162C30.2366 11.5698 30.024 11.675 29.7878 11.7139L20.9798 13.1659C20.8454 13.1883 20.7245 13.2482 20.6375 13.3356C20.5506 13.423 20.5029 13.5325 20.5026 13.6455V15.0519H28.5411V13.889C28.5411 13.6612 28.6509 13.4427 28.8463 13.2816C29.0418 13.1205 29.3069 13.03 29.5833 13.03C29.8597 13.03 30.1248 13.1205 30.3203 13.2816C30.5158 13.4427 30.6256 13.6612 30.6256 13.889V20.9953C30.6256 21.1457 30.5777 21.2935 30.4866 21.4239L26.756 26.7638L33.3176 24.8084C33.5463 24.7402 33.7967 24.7402 34.0254 24.8084L40.6101 26.7647L36.859 21.4259C36.767 21.2951 36.7186 21.1466 36.7186 20.9954V13.8889C36.7186 13.661 36.8285 13.4426 37.0239 13.2815C37.2194 13.1204 37.4845 13.0299 37.7609 13.0299C38.0373 13.0299 38.3024 13.1204 38.4979 13.2815C38.6934 13.4426 38.8032 13.661 38.8032 13.8889V15.0519H46.8416ZM33.5543 18.7684C33.2997 18.7684 33.0507 18.7062 32.8389 18.5896C32.6271 18.473 32.462 18.3073 32.3645 18.1134C32.267 17.9195 32.2415 17.7061 32.2912 17.5002C32.3408 17.2944 32.4634 17.1052 32.6435 16.9568C32.8236 16.8084 33.053 16.7073 33.3028 16.6663C33.5526 16.6253 33.8115 16.6463 34.0468 16.7266C34.2821 16.8069 34.4832 16.9429 34.6248 17.1174C34.7663 17.2919 34.8418 17.4971 34.8419 17.707C34.8415 17.9883 34.7058 18.2581 34.4644 18.4571C34.223 18.6561 33.8957 18.768 33.5543 18.7684ZM33.5543 14.7242C33.2997 14.7242 33.0508 14.662 32.839 14.5454C32.6273 14.4288 32.4623 14.2631 32.3648 14.0692C32.2674 13.8753 32.2419 13.6619 32.2915 13.4561C32.3412 13.2502 32.4638 13.0612 32.6439 12.9128C32.824 12.7644 33.0534 12.6633 33.3031 12.6224C33.5529 12.5814 33.8118 12.6024 34.0471 12.6827C34.2823 12.7631 34.4834 12.8991 34.6249 13.0736C34.7664 13.2481 34.8419 13.4532 34.8419 13.6631C34.8415 13.9444 34.7057 14.2141 34.4643 14.413C34.2229 14.612 33.8957 14.7239 33.5543 14.7242ZM33.5543 10.6803C33.2996 10.6803 33.0506 10.6181 32.8389 10.5015C32.6271 10.3849 32.462 10.2192 32.3645 10.0252C32.267 9.83132 32.2415 9.61792 32.2912 9.41205C32.3409 9.20617 32.4635 9.01706 32.6436 8.86863C32.8237 8.7202 33.0532 8.61912 33.303 8.57818C33.5528 8.53723 33.8117 8.55826 34.047 8.6386C34.2823 8.71895 34.4835 8.85499 34.6249 9.02954C34.7664 9.20408 34.8419 9.40929 34.8419 9.61919C34.8415 9.90052 34.7057 10.1702 34.4643 10.3691C34.2229 10.5681 33.8957 10.68 33.5543 10.6803ZM33.5543 6.63642C33.2996 6.63644 33.0507 6.57423 32.8389 6.45763C32.6271 6.34104 32.462 6.1753 32.3645 5.98138C32.267 5.78746 32.2415 5.57408 32.2912 5.3682C32.3408 5.16233 32.4635 4.97322 32.6435 4.82478C32.8236 4.67635 33.0531 4.57526 33.3029 4.5343C33.5527 4.49334 33.8116 4.51435 34.0469 4.59467C34.2822 4.67499 34.4833 4.81101 34.6248 4.98554C34.7664 5.16006 34.8419 5.36525 34.8419 5.57516C34.8415 5.8565 34.7057 6.12624 34.4644 6.32519C34.223 6.52415 33.8957 6.63608 33.5543 6.63642Z",
    fill: "url(#paint10_linear_959_1739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6747 17.205C33.5178 17.205 33.3644 17.237 33.2339 17.297C33.1034 17.357 33.0018 17.4424 32.9417 17.5422C32.8817 17.642 32.866 17.7518 32.8966 17.8578C32.9272 17.9637 33.0028 18.0611 33.1138 18.1375C33.2247 18.2138 33.3661 18.2658 33.52 18.2869C33.6739 18.308 33.8335 18.2971 33.9784 18.2558C34.1234 18.2144 34.2473 18.1444 34.3344 18.0546C34.4216 17.9647 34.4681 17.8591 34.468 17.7511C34.4677 17.6063 34.384 17.4675 34.2353 17.3651C34.0866 17.2627 33.885 17.2051 33.6747 17.205Z",
    fill: "#073B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6749 13.1094C33.5179 13.1093 33.3645 13.1494 33.2341 13.2244C33.1036 13.2994 33.0019 13.406 32.9418 13.5308C32.8817 13.6555 32.866 13.7928 32.8966 13.9253C32.9272 14.0577 33.0027 14.1794 33.1137 14.2749C33.2246 14.3704 33.366 14.4354 33.5199 14.4618C33.6738 14.4881 33.8333 14.4746 33.9783 14.423C34.1232 14.3713 34.2471 14.2838 34.3343 14.1715C34.4215 14.0592 34.468 13.9272 34.468 13.7921C34.4678 13.6112 34.3841 13.4377 34.2354 13.3097C34.0867 13.1817 33.8852 13.1097 33.6749 13.1094Z",
    fill: "#1C648E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_959_1739",
    x: 0,
    y: 0,
    width: 67.3465,
    height: 71.6331,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.670833 0 0 0 0 0.670833 0 0 0 0 0.670833 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_959_1739"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_959_1739",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_959_1739",
    x: 27.9257,
    y: 33.3193,
    width: 10.2214,
    height: 12.3698,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.869705 0 0 0 0 0.869705 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_959_1739"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_959_1739",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_959_1739",
    x: 27.9257,
    y: 39.3268,
    width: 10.2214,
    height: 14.8278,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.869705 0 0 0 0 0.869705 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_959_1739"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_959_1739",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_959_1739",
    x: 33.0053,
    y: 39.8735,
    width: 9.90402,
    height: 11.8235,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.869705 0 0 0 0 0.869705 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_959_1739"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_959_1739",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_959_1739",
    x: 33.0053,
    y: 30.8611,
    width: 9.90402,
    height: 15.9202,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.869705 0 0 0 0 0.869705 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_959_1739"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_959_1739",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_959_1739",
    x: 23.1697,
    y: 30.8611,
    width: 9.90402,
    height: 12.3698,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.869705 0 0 0 0 0.869705 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_959_1739"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_959_1739",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_959_1739",
    x: 23.1697,
    y: 37.9612,
    width: 9.90402,
    height: 12.3698,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.869705 0 0 0 0 0.869705 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_959_1739"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_959_1739",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_959_1739",
    x1: 26,
    y1: 51,
    x2: 4,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247023,
    stopColor: "#002E53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501463,
    stopColor: "#003D62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690614,
    stopColor: "#00527C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916086,
    stopColor: "#006393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_959_1739",
    x1: 32.5,
    y1: 46,
    x2: 24,
    y2: 62.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F51B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_959_1739",
    x1: 39,
    y1: 44,
    x2: 42.5,
    y2: 63.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F51B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_959_1739",
    x1: 43,
    y1: 54,
    x2: 63,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247023,
    stopColor: "#002E53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501463,
    stopColor: "#003D62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690614,
    stopColor: "#00527C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916086,
    stopColor: "#006393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_959_1739",
    x1: 32.8944,
    y1: 37.8582,
    x2: 32.8944,
    y2: 33.3582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0156724,
    stopColor: "#FFB600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276271,
    stopColor: "#E3A608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565452,
    stopColor: "#C29211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767206,
    stopColor: "#58542F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002147"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_959_1739",
    x1: 32.8944,
    y1: 46.4187,
    x2: 32.8944,
    y2: 39.3874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0156724,
    stopColor: "#FFB600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276271,
    stopColor: "#E3A608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565452,
    stopColor: "#C29211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767206,
    stopColor: "#58542F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002147"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_959_1739",
    x1: 37.8357,
    y1: 43.845,
    x2: 37.8357,
    y2: 39.9075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0156724,
    stopColor: "#FFB600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276271,
    stopColor: "#E3A608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565452,
    stopColor: "#C29211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767206,
    stopColor: "#58542F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002147"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_959_1739",
    x1: 37.8357,
    y1: 39.0877,
    x2: 37.8357,
    y2: 30.9314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0156724,
    stopColor: "#FFB600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276271,
    stopColor: "#E3A608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565452,
    stopColor: "#C29211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767206,
    stopColor: "#58542F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002147"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_959_1739",
    x1: 28,
    y1: 35.3999,
    x2: 28,
    y2: 30.8999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0156724,
    stopColor: "#FFB601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341488,
    stopColor: "#E3A608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565452,
    stopColor: "#C29211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767206,
    stopColor: "#58542F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002147"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_959_1739",
    x1: 28,
    y1: 42.5,
    x2: 28,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0156724,
    stopColor: "#FFB600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276271,
    stopColor: "#E3A608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565452,
    stopColor: "#C29211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767206,
    stopColor: "#58542F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002147"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_959_1739",
    x1: 33,
    y1: 29.5,
    x2: 33.5,
    y2: 9.65211e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197633,
    stopColor: "#073B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4452,
    stopColor: "#1C648E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#2587B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#289FD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAE1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsIcon);
export default __webpack_public_path__ + "static/media/ProjectsIcon.9a07ac3a3ae768c510a491e84e58d2da.svg";
export { ForwardRef as ReactComponent };